module.exports = __webpack_public_path__ + "static/media/5_Desk-featured_logos.d2a81242.jpg";